import { Navigate, Route, Routes } from "react-router-dom";
import { AppLayout } from "./components/layout/AppLayout";
import { CashoutPage } from "./pages/CashoutPage";
import { DashboardPage } from "./pages/DashboardPage";
import { EarningsHistoryPage } from "./pages/EarningsHistoryPage";
import Error404 from "./pages/Error404";
import FlexRedirect from "./pages/FlexRedirect";
import { ProfileEditPage } from "./pages/ProfileEditPage";
import { ProfilePage } from "./pages/ProfilePage";
import { ErrorPage } from "./pages/redirects/ErrorPage";
import { TaskDetailPage } from "./pages/TaskDetailPage";

export function App() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="dashboard" element={<Navigate to="/" />} />
        <Route path="tasks" element={<DashboardPage />} />
        {/* <Route path="tasks/reveal" element={<TaskRevealPage />} /> */}
        <Route path="tasks/:taskId">
          <Route index element={<TaskDetailPage />} />
        </Route>
        <Route path="tasks/:taskId/redirect/error" element={<ErrorPage />} />
        <Route path="earnings" element={<EarningsHistoryPage />} />
        <Route path="cashout" element={<CashoutPage />} />
        <Route path="checkin/:checkInId" element={<ProfileEditPage />} />
        <Route path="profile/edit" element={<ProfileEditPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="flex" element={<FlexRedirect />} />
        <Route path="*" element={<Error404 />} />
      </Route>
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
}
